function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#BF368B",
  strokeWidth: 4,
  transform: "translate(0 3)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  x2: 26,
  y1: 1.015,
  y2: 1.015,
  transform: "translate(0 8.985)"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  transform: "translate(16.5)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.345,
  x2: 10,
  y1: 0.345,
  y2: 10
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.345,
  x2: 10,
  y1: 19.742,
  y2: 10.086
})));

function SvgArrowSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26"
  }, props), _ref);
}

export default __webpack_public_path__ + "media/schedule/images/arrow_schedule-f63e6b324edc2f09d0de9a158b6d27bc.svg";
export { SvgArrowSchedule as ReactComponent };